export default __webpack_public_path__ + "static/kruti-patel-goyal-865a807aa63531e05c07688ccce7109a.jpg";